<ng-template [ngIf]="beniMobiliForm">
<div>
	<div class="col-sm-12 coldx">
		<h4 *ngIf="title">{{title}}</h4>
		<form [formGroup]="beniMobiliForm" (ngSubmit)="update();">
			<div class="row">
				<div comboModInput class="col-sm-3"
					[(ngModel)]="beneMobileRequest.tipoBeneMobile"
					[control]="beniMobiliForm.controls['tipoBene']"
					[labelInput]="'Tipo bene'" formControlName="tipoBene"
					[objectReference]="beneMobileRequest.tipoBeneMobile"
					[mandatory]="true"
					(onReturn)="beneMobileRequest.tipoBeneMobile = $event"
					[optionsCombo] ="tipiBene"></div>

				<div textInputCurrency class="col-sm-3" [control]="beniMobiliForm.controls['valoreBene']"
					[labelInput]="'Valore del bene'" [location]="'SezioneEconomica'"
					formControlName="valoreBene" [(ngModel)]="beneMobileRequest.valore"></div>

<!-- 				<div textInput class="col-sm-3" [labelInput]="'Valore del bene'" -->
<!-- 					formControlName="valoreBene" [(ngModel)]="beneMobileRequest.valore"></div> -->

				<div checkBoxRadio class="col-sm-3"
					[labelInput]="'Ipoteca'"
          [idInput]="inserimento ? 'ipoteca-ins' : 'ipoteca-mod'"
					formControlName="ipoteca"
					[objectReference]="beneMobileRequest.ipoteca"
					(onReturn)="changedIpoteca($event)"></div>

				<div textInputCurrency class="col-sm-3" [control]="beniMobiliForm.controls['valoreIpoteca']"
					[labelInput]="'Valore ipoteca'" [location]="'SezioneEconomica'"
					[submitPending]="!beneMobileRequest.ipoteca"
					formControlName="valoreIpoteca" [(ngModel)]="beneMobileRequest.valoreIpoteca"></div>

<!-- 				<div textInput class="col-sm-3" [labelInput]="'Valore ipoteca'" -->
<!-- 					[submitPending]="!beneMobileRequest.ipoteca" -->
<!-- 					formControlName="valoreIpoteca" -->
<!-- 					[(ngModel)]="beneMobileRequest.valoreIpoteca"></div> -->
			</div>

			<div class="row">
				<div textInputCurrency class="col-sm-3" [control]="beniMobiliForm.controls['quantita']"
					[labelInput]="'Quantit&agrave;'" [isNaturalNumber]="true" [location]="'SezioneEconomica'"
					formControlName="quantita" [(ngModel)]="beneMobileRequest.quantita"></div>

<!-- 				<div textInput class="col-sm-3" [labelInput]="'Quantit&agrave;'" -->
<!-- 					formControlName="quantita" [(ngModel)]="beneMobileRequest.quantita"> -->
<!-- 				</div> -->

				<div textInput class="col-sm-3"
					[labelInput]="'Unit&agrave; di misura'"
					formControlName="unitaMisura"
					[(ngModel)]="beneMobileRequest.unitaMisura"></div>

				<div datePickerInput class="col-sm-3"
					[labelInput]="'Data inventario'" formControlName="dataInventario"
					[(ngModel)]="beneMobileRequest.dataInventario"></div>

				<div textInput class="col-sm-3"
					[labelInput]="'Riferimento inventario'"
					formControlName="riferimentoInventario"
					[(ngModel)]="beneMobileRequest.riferimentoInventario"></div>
			</div>

			<div class="row">
				<div textInputCurrency class="col-sm-3" [labelInput]="'Diritti reali %'"
					[control]="beniMobiliForm.controls['quota']" [location]="'SezioneEconomica'"
					formControlName="quota" [maxValue]="100"
					[(ngModel)]="beneMobileRequest.quota"></div>
				<div comboModInput class="col-sm-3"
					[(ngModel)]="beneMobileRequest.tipoDirittoReale"
					[control]="beniMobiliForm.controls['tipoDirittoReale']"
					[labelInput]="'Tipo diritto reale'" formControlName="tipoDirittoReale"
					[objectReference]="beneMobileRequest.tipoDirittoReale"
					(onReturn)="beneMobileRequest.tipoDirittoReale = $event"
					[optionsCombo] ="tipoDirittoRealeOptions"></div>
				<div textAreaInput class="col-sm-6"
					[labelInput]="'Descrizione del bene'"
					formControlName="descrizioneBene"
					[(ngModel)]="beneMobileRequest.descrizione"></div>
			</div>

			<div class="row container_fieldset">
				<fieldset class="form-group">
					<legend>Ubicazione</legend>
					<div textInput class="col-sm-4" [labelInput]="'Via'"
						formControlName="via"
						[(ngModel)]="beneMobileRequest.ubicazione.via"></div>

					<div textInput class="col-sm-4" [labelInput]="'Civico'"
						formControlName="civico"
						[(ngModel)]="beneMobileRequest.ubicazione.civico"></div>

					<div naturalNumberInput class="col-sm-4" [maxLength]="'5'" [labelInput]="'Cap'"
						formControlName="cap" [checkFormat]="true"
						[(ngModel)]="beneMobileRequest.ubicazione.cap"></div>

					<div comboModInput class="col-sm-4" [labelInput]="'Provincia'"
						formControlName="provincia"
						[objectReference]="beneMobileRequest.ubicazione.provincia"
						(onReturn)="changedProvincia($event)"
						[optionsCombo] ="provinceOptions"></div>

					<div comboModInput class="col-sm-4" [labelInput]="'Citt&agrave;'"
						formControlName="citta"
						[objectReference]="beneMobileRequest.ubicazione.localita"
						(onReturn)="beneMobileRequest.ubicazione.localita = $event"
						[optionsCombo] ="cittaOptions"></div>

					<div textInput class="col-sm-4" [labelInput]="'Nazione'"
						formControlName="nazione"
						[(ngModel)]="beneMobileRequest.ubicazione.nazione"></div>
				</fieldset>
			</div>

			<div class="row container_fieldset">
				<fieldset class="form-group">
					<legend>Somme impegnate</legend>

					<div datePickerInput class="col-sm-6" [labelInput]="'Data somma bloccata'" formControlName="dataBloccoSomma"
						[submitPending]="!beneMobileRequest.sommaBloccata" [(ngModel)]="beneMobileRequest.dataBloccoSomma"></div>

					<div textInputCurrency class="col-sm-6"
						[labelInput]="'Somma bloccata'" [location]="'SezioneEconomica'"
						formControlName="sommaBloccata" [(ngModel)]="beneMobileRequest.sommaBloccata"
						(change)="changedSommaBloccata($event)"></div>

					<div datePickerInput class="col-sm-6" [labelInput]="'Data somma svincolata'" formControlName="dataSvincoloSomma"
					[submitPending]="!beneMobileRequest.sommaSvincolata" [(ngModel)]="beneMobileRequest.dataSvincoloSomma"></div>

					<div textInputCurrency class="col-sm-6"
						[labelInput]="'Somma svincolata'" [location]="'SezioneEconomica'"
						formControlName="sommaSvincolata" [(ngModel)]="beneMobileRequest.sommaSvincolata"
						(change)="changedSommaSvincolata($event)"></div>

					<div class="col-sm-6 col-sm-offset-6"
						 *ngFor="let importoRimastoAccantonato of [( getDiff( beneMobileRequest.sommaBloccata , beneMobileRequest.sommaSvincolata ) )]">
						<p><label for="imp-rim-acc-lbl">Importo rimasto accantonato</label>
						<input id="imp-rim-acc-lbl" class="totale form-control" disabled="" value="{{ (beneMobileRequest.sommaBloccata || beneMobileRequest.sommaSvincolata ) ? (importoRimastoAccantonato | euro)+' \u20AC' : ''}}" type="text"></p>
					</div>
				</fieldset>
			</div>

			<div class="row container_fieldset">
				<fieldset class="form-group">
					<legend>Istanza di vendita</legend>

					<div checkBoxRadio class="col-sm-3"
						[labelInput]="'Vendita'"
            [idInput]="inserimento ? 'vendita-ins' : 'vendita-mod'"
						formControlName="vendita"
						[objectReference]="beneMobileRequest.istanzaVendita.vendita"
						(onReturn)="changedVendita($event)"></div>

					<div datePickerInput class="col-sm-3" [labelInput]="'Data'"
						formControlName="dataVendita"
						[submitPending]="!beneMobileRequest.istanzaVendita.vendita"
						[(ngModel)]="beneMobileRequest.istanzaVendita.dataIstanza">
					</div>

					<div textInput class="col-sm-3" [labelInput]="'Acquirente'"
						formControlName="acquirente"
						[submitPending]="!beneMobileRequest.istanzaVendita.vendita"
						[(ngModel)]="beneMobileRequest.istanzaVendita.acquirente"></div>

					<div textInputCurrency class="col-sm-3" [control]="beniMobiliForm.controls['ricavato']"
						[labelInput]="'Ricavato'" [location]="'SezioneEconomica'"
						[submitPending]="!beneMobileRequest.istanzaVendita.vendita"
						formControlName="ricavato" [(ngModel)]="beneMobileRequest.istanzaVendita.ricavato"></div>

				</fieldset>
			</div>

			<div class="row container_fieldset">
				<fieldset class="form-group">
					<legend>Istanza di assegnazione</legend>
					<div checkBoxRadio class="col-sm-6"
						[labelInput]="'Assegnato'"
            [idInput]="inserimento ? 'assegnato-ins' : 'assegnato-mod'"
						formControlName="assegnato"
						[objectReference]="beneMobileRequest.istanzaAssegnazione.assegnato"
						(onReturn)="changedAssegnazione($event)"></div>

					<div datePickerInput class="col-sm-6" [labelInput]="'Data'"
						formControlName="dataAssegnazione"
						[submitPending]="!beneMobileRequest.istanzaAssegnazione.assegnato"
						[(ngModel)]="beneMobileRequest.istanzaAssegnazione.dataIstanza">
					</div>
				</fieldset>
			</div>

			<div class="row">
				<div textAreaInput class="col-sm-12" [labelInput]="'Note'"
					formControlName="note" [(ngModel)]="beneMobileRequest.note"></div>
			</div>

			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>

			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="createForm();">Reset</button>
				</p>
				<p submitButton
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'" [disabled]='!beniMobiliForm.valid'>
			</div>
		</form>
	</div>
</div>
</ng-template>
